var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search",
      style: {
        padding: _vm.searchPadding,
      },
    },
    [
      _vm.propsData.isLogo
        ? _c("img", {
            staticClass: "logo",
            attrs: { src: _vm.propsData.logoUrl, alt: "" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input",
          style: !_vm.propsData.isLogo ? "width: 100%; " : "",
        },
        [
          _c("i", { staticClass: "iconfont el-icon-search" }),
          _vm._v(" "),
          _c("div", [
            _vm._v(_vm._s(_vm.propsData.searchDefault || "搜索商品")),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }